import React from 'react';

import {HealthConfirmationBooking} from 'presentation/modules/booking/health/ui/pages/HealthConfirmationBooking';

export const MakeHealthConfirmationBooking = () => {
	return <HealthConfirmationBooking />;
};
